import styled from 'styled-components';

import { Accordion, Avatar } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const FiltersContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const AccordionStyled = styled(Accordion)`
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
  border-bottom: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })} 1px solid;

  & > div:first-child {
    height: 34px;
    width: 100%;
    align-items: center;

    & svg {
      width: 18px;
      height: 18px;
    }

    & p {
      padding: 0 16px;
    }
  }

  & > div:nth-child(2) {
    width: 100%;
  }
`;

export const AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
`;

export const CategoryCount = styled(Avatar)`
  height: 18px;
  width: 18px;
  background-color: ${ct({ Dark: Colors.Light, Light: Colors.Light })};
  color: ${ct({ Dark: Colors.Dark, Light: Colors.Dark })};
  font-size: 10px;
  font-weight: 600;
`;

export const AccordionContent = styled.div`
  padding: 12px;
`;
